import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { fetchViewerProfileQuery, postDashboardOpened } from "../../../behavior/api/viewer";
import { PageRoute } from "../../../constants";
import { Button } from "../../elements";
import { useReuseToken } from "../../../pages/login/RealTimeScreening/Login";
import type Application from "../../../types/application";

interface StartInterviewButtonProps {
    btnLabel: string;
    application: Application;
    hidden?: boolean;
}

const StartInterviewButton = ({ btnLabel, application, hidden }: StartInterviewButtonProps) => {
    const navigate = useNavigate();
    const { data: viewer } = useQuery({
        queryKey: ["viewer", "profile"],
        queryFn: fetchViewerProfileQuery(),
    });
    const reuse = useReuseToken();

    const startInterview = async () => {
        await postDashboardOpened(application.id);
        const jobId = application.job?.id ?? application.jobId;
        if (!jobId) {
            return;
        }
        const { token } = await reuse.getReuseData(jobId);

        if (!application.interview || !token) {
            return;
        }
        const displayName = viewer?.displayName ?? viewer?.email;

        const urlSearchParams = new URLSearchParams({
            interviewId: application.interview.publicId,
            reuse: token,
            displayName: displayName ?? "",
        });
        navigate(`${PageRoute.PRE_INTERVIEW}?${urlSearchParams}`);
    };

    return (
        <>
            <Button size="small" hidden={hidden} disabled={!viewer} onClick={startInterview}>
                {btnLabel}
            </Button>
        </>
    );
};

export default StartInterviewButton;
